import { render, staticRenderFns } from "./PaymentDetails.vue?vue&type=template&id=5fecf830"
import script from "./PaymentDetails.vue?vue&type=script&lang=js"
export * from "./PaymentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports